import ConsentPickerItem from "./ConsentPickerItem";
import { blockTypes } from "../blockTypes";
import { Typography } from "@mui/material";
import { CBPickerWrapper } from "../block.style";

const ConsentPicker = () => {
  return (
    <CBPickerWrapper>
      <Typography
        color="text.primary"
        variant="body1"
        fontWeight={"medium"}
        sx={{ mb: 1 }}
      >
        Select a block type
      </Typography>
      <Typography
        color="text.secondary"
        fontWeight={"light"}
        variant="body2"
        sx={{ mb: 3 }}
      >
        Select new block types to the left. Edit or rearrange them after.
      </Typography>
      <div>
        {blockTypes.map((blockType) => (
          <ConsentPickerItem key={blockType.key} blockType={blockType} />
        ))}
      </div>
    </CBPickerWrapper>
  );
};

export default ConsentPicker;
